<template>
  <div class="parent">
    <div class="d-flex flex-row justify-content-center footer-container">
      <RouterLink custom :to="{ name: 'Search' }" v-slot="{ href, navigate }">
        <span class="section text-center" :href="href" @click="navigate">
          <!-- クエリが付与される可能性があるため、isActiveを条件とする -->
          <SearchIcon
            :checked="isActiveSearchLink"
            :wrapper-class="textColor(isActiveSearchLink)"
          />
          <p class="icon-text" :class="textColor(isActiveSearchLink)">
            探す
          </p>
        </span>
      </RouterLink>
      <RouterLink
        custom
        :to="{ name: 'ApplicationsList', query: $route.query }"
        v-slot="{ href, navigate, isActive }"
      >
        <template v-if="isLoggedIn">
          <span class="section text-center" :href="href" @click="navigate">
            <AppBadge
              variant="red"
              class="rejected-num"
              v-if="notificationApplicationCount !== 0"
            >
              {{ notificationApplicationCount }}
            </AppBadge>
            <BriefcaseIcon
              :checked="isActive"
              :wrapper-class="textColor(isActive)"
            />
            <p class="icon-text" :class="textColor(isActive)">
              仕事管理
            </p>
          </span>
        </template>
        <template v-else>
          <span class="section text-center" @click="confirmLogin">
            <BriefcaseIcon
              :checked="isActive"
              :wrapper-class="textColor(isActive)"
            />
            <p class="icon-text" :class="textColor(isActive)">
              仕事管理
            </p>
          </span>
        </template>
      </RouterLink>
      <RouterLink
        custom
        :to="{ name: 'MessageRooms' }"
        v-slot="{ href, navigate, isExactActive }"
      >
        <template v-if="isLoggedIn">
          <span class="section text-center" :href="href" @click="navigate">
            <AppBadge
              variant="red"
              class="notification"
              v-if="unreadMessageAndInformationCount !== 0"
            >
              {{ unreadMessageAndInformationCount }}
            </AppBadge>
            <MessageSquareIcon
              :checked="isExactActive"
              :wrapper-class="textColor(isExactActive)"
            />
            <p class="icon-text" :class="textColor(isExactActive)">
              メッセージ
            </p>
          </span>
        </template>
        <template v-else>
          <span class="section text-center" @click="confirmLogin">
            <AppBadge
              variant="red"
              class="notification"
              v-if="unreadMessageAndInformationCount !== 0"
            >
              {{ unreadMessageAndInformationCount }}
            </AppBadge>
            <MessageSquareIcon
              :checked="isExactActive"
              :wrapper-class="textColor(isExactActive)"
            />
            <p class="icon-text" :class="textColor(isExactActive)">
              メッセージ
            </p>
          </span>
        </template>
      </RouterLink>
      <RouterLink custom :to="{ name: 'FavList' }" v-slot="{ href, navigate }">
        <span
          class="section text-center"
          :href="href"
          @click="isLoggedIn ? navigate($event) : confirmLogin()"
        >
          <FavoriteAndWatchLaterIcon
            :checked="isActiveFavoriteLink"
            :wrapper-class="textColor(isActiveFavoriteLink)"
          />
          <p class="icon-text" :class="textColor(isActiveFavoriteLink)">
            お気に入り
          </p>
        </span>
      </RouterLink>
      <RouterLink
        custom
        :to="{ name: 'Mypage' }"
        v-slot="{ href, navigate, isExactActive }"
      >
        <template v-if="isLoggedIn">
          <span class="section text-center" :href="href" @click="navigate">
            <AppBadge
              variant="red"
              class="rejected-num"
              v-if="rejectedNum !== 0"
            >
              {{ rejectedNum }}
            </AppBadge>
            <UserIcon
              :checked="isExactActive"
              :wrapper-class="textColor(isExactActive)"
            />
            <p class="icon-text" :class="textColor(isExactActive)">
              マイページ
            </p>
          </span>
        </template>
        <template v-else>
          <span class="section text-center" @click="confirmLogin">
            <AppBadge
              variant="red"
              class="rejected-num"
              v-if="rejectedNum !== 0"
            >
              {{ rejectedNum }}
            </AppBadge>
            <UserIcon
              :checked="isExactActive"
              :wrapper-class="textColor(isExactActive)"
            />
            <p class="icon-text" :class="textColor(isExactActive)">
              マイページ
            </p>
          </span>
        </template>
      </RouterLink>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import AppBadge from "@/components/atoms/other/AppBadge.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import FavoriteAndWatchLaterIcon from "@/components/atoms/other/FavoriteAndWatchLaterIcon.vue";
import BriefcaseIcon from "@/components/atoms/other/BriefcaseIcon.vue";
import SearchIcon from "@/components/atoms/other/SearchIcon.vue";
import MessageSquareIcon from "@/components/atoms/other/MessageSquareIcon.vue";
import UserIcon from "@/components/atoms/other/UserIcon.vue";
import { messageStore } from "@/store/message";
import { authStore } from "@/store/auth";
import { applicationStore } from "@/store/application";
import { accountService } from "@/app/services/AccountService";
import { UserQualification } from "@/types/qualification/UserQualification";
import { useLoginModal } from "@/utils/modal";

@Component({
  components: {
    AppBadge,
    FavoriteAndWatchLaterIcon,
    FeatherIcon,
    BriefcaseIcon,
    SearchIcon,
    MessageSquareIcon,
    UserIcon
  }
})
export default class AppFooter extends Vue {
  notificationIntervalId: number | null = null;
  qualificationIntervalId: number | null = null;
  accountIntervalId: number | null = null;
  creditScoreIntervalId: number | null = null;
  qualifications: UserQualification[] = [];
  loginModal = useLoginModal();

  get user() {
    return authStore.user;
  }

  get unreadMessageAndInformationCount() {
    return (
      messageStore.unreadMessageCount + messageStore.unreadInformationCount
    );
  }

  get rejectedNum() {
    if (!this.user) return 0;

    const verifiedStatus = this.user.verifiedStatus === "rejected";
    const rejectedQualification = this.qualifications.filter(qualification => {
      return qualification.status === "rejected";
    });
    return Number(verifiedStatus) + rejectedQualification.length;
  }

  get isLoggedIn() {
    return authStore.existToken;
  }

  get notificationApplicationCount() {
    return applicationStore.notificationApplicationCount;
  }

  get isActiveSearchLink() {
    return (
      this.$route.name === "Search" ||
      this.$route.name === "SearchLimitedOrders" ||
      this.$route.name === "SearchIndividualOfferOrders"
    );
  }

  get isActiveFavoriteLink() {
    return (
      this.$route.name === "FavList" || this.$route.name === "WatchLaterOrders"
    );
  }

  async created() {
    // 未ログイン時は何もしない
    if (!authStore.existToken) return;

    // メッセージタブのバッジ件数、アプリバッジ件数のポーリング
    await Promise.all([
      messageStore.fetchUnreadMessageCount(),
      messageStore.fetchUnreadInformationCount()
    ]);
    this.notificationIntervalId = window.setInterval(async () => {
      await accountService.refreshAppBadgeCount();
      await messageStore.fetchUnreadMessageCount();
      await messageStore.fetchUnreadInformationCount();
    }, 60000);

    // アカウント情報のポーリング
    await accountService.updateUserData();
    this.accountIntervalId = window.setInterval(
      accountService.updateUserData,
      300000
    );

    // 案件応募情報を取得（フッターの無い画面でも使うので、ポーリングはApp.vueで実施）
    // 取得処理がすでに実行中だった場合は何もしない
    if (!applicationStore.isFetchingApplications) {
      await applicationStore.fetchApplications();
    }

    // 資格情報のポーリング
    await this.fetchQualification();
    this.qualificationIntervalId = window.setInterval(
      this.fetchQualification,
      300000
    );

    // アプリがフォアグラウンドに復帰した際にはバッチ件数の最新化をする
    document.addEventListener("resume", async () => {
      await accountService.refreshAppBadgeCount();
      await accountService.updateUserData();
      await this.fetchQualification();
    });
  }

  unmounted() {
    if (this.notificationIntervalId) {
      clearInterval(this.notificationIntervalId);
    }
    if (this.qualificationIntervalId) {
      clearInterval(this.qualificationIntervalId);
    }
    if (this.accountIntervalId) {
      clearInterval(this.accountIntervalId);
    }
  }

  async fetchQualification() {
    this.qualifications = (await accountService.fetchQualifications()).results;
  }

  async confirmLogin() {
    if (this.isLoggedIn) return;
    const isConfirmed = await this.loginModal.showLoginModal();
    if (!isConfirmed) return;
    await this.$router.push({ name: "Welcome" });
  }

  textColor(isActive: boolean) {
    return isActive ? "text-active" : "text-inactive";
  }
}
</script>

<style lang="scss" scoped>
.section {
  position: relative;
  width: 75px;
}

.icon-text {
  /* user agent style sheetの影響があるのでremではなくpx指定 */
  font-size: 10px;
  font-weight: 500;
}

.footer-container {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1000;
  width: 100vw;
  height: 80px;
  padding-top: 5px;
  padding-bottom: 30px;
  background-color: #fff;
  box-shadow: 0 -1px 0 rgb(0 0 0 / 30%);
}

.parent {
  bottom: 0;
  padding-bottom: 80px;
}

.notification {
  position: absolute;
  top: -2px;
  left: 38px;
}

.rejected-num {
  position: absolute;
  top: -2px;
  left: 38px;
}

.text-active {
  color: #343434;
}

.text-inactive {
  color: #343434;
}
</style>
